import { Contract } from 'components/molecules';
import { useFormikContext } from 'formik';
import { AGREEMENT_TYPE } from 'services/templates/agreement-template/types';
import { IContractTemplateForm } from 'services/templates/types';

interface IContractAgreementDetailsProps {}

const ContractAgreementDetails = ({}: IContractAgreementDetailsProps) => {
  const { values } = useFormikContext<IContractTemplateForm>();

  return (
    <Contract.SideMenu.AgreementDetail.Page>
      {values.sideMenu?.detail?.content.type === AGREEMENT_TYPE.text && (
        <Contract.SideMenu.AgreementDetail.Agreement.Text />
      )}
      {values.sideMenu?.detail?.content.type === AGREEMENT_TYPE.select && (
        <Contract.SideMenu.AgreementDetail.Agreement.Select />
      )}
      {values.sideMenu?.detail?.content.type === AGREEMENT_TYPE.paragraph && (
        <Contract.SideMenu.AgreementDetail.Agreement.Paragraph />
      )}
    </Contract.SideMenu.AgreementDetail.Page>
  );
};

export default ContractAgreementDetails;
